import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";

const getNotes = async (
  caseId?: string,
  participantId?: number,
  invoiceId?: string,
) => {
  const query = new URLSearchParams(window.location.search);

  if (caseId?.length) {
    query.append("caseId", caseId);
  }

  if (participantId) {
    query.append("participantId", participantId.toString());
  }

  if (invoiceId?.length) {
    query.append("invoiceId", invoiceId);
  }

  const r = await axiosInstance.get(`/notes?${query}`);

  return r.data ?? [];
};

const useGetNotes = (
  caseId?: string,
  participantId?: number,
  invoiceId?: string,
) => {
  return useCustomQuery("notes", () =>
    getNotes(caseId, participantId, invoiceId),
  );
};

export interface ICreateNote {
  Title: string;
  Content: string;
  CaseId?: string;
  ParticipantId?: number;
  InvoiceId?: string;
  /**
   * ObjectKeys.Id klucza OBIEKTU notatki (utils/encryptNoteFields). Title/Content są nim
   * zaszyfrowane, a on sam owinięty kluczem FIRMY — docs/model-kluczy-firmowych.md,
   * inwariant I1. Puste dla wierszy sprzed migracji Notes.EncryptionKeyId.
   */
  EncryptionKeyId?: string;
}

const createNote = (payload: ICreateNote) => {
  return axiosInstance.post("/note", payload);
};

const useCreateNote = () => {
  return useCustomMutation(createNote);
};

export interface IEditNote {
  Id: string;
  Title: string;
  Content: string;
  /** Nowy klucz obiektu — edycja szyfruje treść od nowa (patrz utils/encryptNoteFields). */
  EncryptionKeyId?: string;
}

const editNote = (payload: IEditNote) => {
  return axiosInstance.put("/note", payload);
};

const useEditNote = () => {
  return useCustomMutation(editNote);
};

export interface IDeleteNote {
  Id: string;
}

const deleteNote = (payload: IDeleteNote) => {
  return axiosInstance.delete("/note", {
    data: payload,
  });
};

const useDeleteNote = () => {
  return useCustomMutation(deleteNote);
};

export default {
  useGetNotes,
  useCreateNote,
  useEditNote,
  useDeleteNote,
};
